const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      title: '계약서 촬영',
      description: '스마트폰 카메라로 계약서를 찍거나 갤러리에서 선택하세요',
    },
    {
      number: 2,
      title: 'AI 자동 분석',
      description: '불공정 조항, 위험 요소를 3초 안에 찾아냅니다',
    },
    {
      number: 3,
      title: '결과 확인',
      description: '위험도와 주의사항을 쉬운 말로 알려드립니다',
    },
  ]

  return (
    <div className="px-4 py-8">
      <h2 className="text-xl font-bold text-black mb-6">이렇게 작동해요</h2>
      <div className="space-y-6">
        {steps.map((step) => (
          <div key={step.number} className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold">{step.number}</span>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-base font-semibold text-black mb-1">
                {step.title}
              </h3>
              <p className="text-sm text-gray-600">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default HowItWorks

